<script>
    import 'vue-strap/dist/vue-strap-lang';
    import { datepicker } from 'vue-strap';
    import tipoContratoServico from '~modulos/tipo-contrato/servico';
    import subTipoContratoServico from '~modulos/sub-tipo-contrato/servico';

    export default {
        components: { datepicker },
        props: {
            solicitacao: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                tiposContrato: [],
                subTiposContrato: [],
                descricaoValor: "Valor mensal",
                configuracao: this.$storage.configuracao(),
            }
        },
        computed: {
            fap() {
                return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FAPUNIFESP';
            },
            validarCargaHoraria() {
                if (!this.configuracao.solBolsaObrigatorioCargaHoraria)
                    return '';

                return (this.solicitacao.tipoBolsa === 1 && !this.solicitacao.cargaHoraria)
                    ? 'required' : '';
            },
            requiredCargaHoraria() { 
                if (!this.configuracao.solBolsaObrigatorioCargaHoraria)
                    return false;

                return (this.solicitacao.tipoBolsa === 1 && !this.solicitacao.cargaHoraria)
                       ? true : false;
            }
        },
        methods: {
            fusp() {
                return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
            },
            validar(valido) {
                if (!valido) throw new Error("validacao com erro");

                return this.$validator.validateAll();
            },
            carregarTiposContrato() {
                if (this.solicitacao.tipoBolsa == "4")
                    return;

                return tipoContratoServico
                    .lista(this.solicitacao.tipoBolsa)
                    .then(tiposContrato => {
                        this.tiposContrato = tiposContrato;

                        if (tiposContrato) {
                            if (tiposContrato.length == 1) {
                                this.solicitacao.idTipoContrato = tiposContrato[0].idTipoContrato;
                                this.carregarSubTiposContrato();
                            }
                        }
                    });
            },
            carregarSubTiposContrato() {
                this.subTiposContrato = [];
                this.solicitacao.idSubTipoContrato = '';

                if (!this.solicitacao.idTipoContrato) {
                    return
                }

                return subTipoContratoServico
                    .lista(this.solicitacao.idTipoContrato)
                    .then(subTiposContrato => {
                        this.subTiposContrato = subTiposContrato;
                    });
            },
            descricaoValorBolsa() {
                if (this.solicitacao.tipoBolsa === 2) {
                    this.descricaoValor = "Valor total do serviço"
                    return
                }

                if (this.solicitacao.tipoBolsa === 5 && this.fusp()) {
                    this.descricaoValor = "Valor mensal do adicional"
                    return
                }

                this.descricaoValor = "Valor mensal"
            },
        },
        mounted() {
            //$('.datepicker input').attr('readonly', '');

            this.carregarTiposContrato();
        },
        watch: {
            'solicitacao.tipoBolsa': 'descricaoValorBolsa'
        }
    }
</script>

<template>
    <div>

        <div class="row">
            <div :class="{'col-lg-6': this.solicitacao.tipoBolsa === 1,'col-lg-4': (this.solicitacao.tipoBolsa === 2 || this.solicitacao.tipoBolsa === 5), 'col-lg-2': (this.solicitacao.tipoBolsa !== 2 && this.solicitacao.tipoBolsa !== 5)}">
                <div class="form-group required" :class="{'has-error': errors.has('valorContrato')}">
                    <label class="control-label" for="valor-contrato">{{this.descricaoValor}}</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-contrato"
                           v-model="solicitacao.valorContrato"
                           data-vv-name="valorContrato"
                           data-vv-as="valor contrato"
                           v-validate="'required'"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorContrato')">{{ errors.first('valorContrato') }}</p>
                </div>
            </div>

            <div class="col-lg-2" v-if="(this.solicitacao.tipoBolsa !== 2 && this.solicitacao.tipoBolsa !== 5)">
                <div class="form-group" :class="{'has-error': errors.has('cargahoraria'), 'required': requiredCargaHoraria}">
                    <label class="control-label" for="nome">Carga horária</label>

                    <input type="text"
                           class="form-control"
                           id="cargahoraria"
                           v-model="solicitacao.cargaHoraria"
                           data-vv-name="cargahoraria"
                           data-vv-as="carga horária"
                           v-validate="validarCargaHoraria"
                           maxlength="50">

                    <p class="text-danger" v-show="errors.has('cargahoraria')">{{ errors.first('cargahoraria') }}</p>
                </div>
            </div>

            <div class="col-lg-2" v-if="this.solicitacao.tipoBolsa === 1">
                <div class="form-group" :class="{'has-error': errors.has('curso')}">
                    <label class="control-label" for="nome">Curso</label>

                    <input type="text"
                           class="form-control"
                           id="curso"
                           v-model="solicitacao.cursoDoContratado"
                           data-vv-name="curso"
                           data-vv-as="curso"
                           maxlength="200">

                    <p class="text-danger" v-show="errors.has('curso')">{{ errors.first('curso') }}</p>
                </div>
            </div>

            <div :class="{'col-lg-3': this.solicitacao.tipoBolsa === 1, 'col-lg-4': this.solicitacao.tipoBolsa !== 1}">
                <div class="form-group required" :class="{'has-error': errors.has('dataVigenciaInicio')}">
                    <label class="control-label">Vigência início</label>

                    <datepicker id="dataVigenciaInicio"
                                v-mascara="'data-mask'"
                                v-model="solicitacao.dataVigenciaInicio"
                                format="dd/MM/yyyy"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="dataVigenciaInicio"
                                data-vv-as="vigência início"
                                v-validate="'required|date_format:DD/MM/YYYY'">
                    </datepicker>

                    <p class="text-danger" v-show="errors.has('dataVigenciaInicio')">{{ errors.first('dataVigenciaInicio') }}</p>
                </div>
            </div>

            <div :class="{'col-lg-3': this.solicitacao.tipoBolsa === 1, 'col-lg-4': this.solicitacao.tipoBolsa !== 1}">
                <div class="form-group required" :class="{'has-error': errors.has('dataVigenciaFim')}">
                    <label class="control-label">Vigência fim</label>

                    <datepicker id="dataVigenciaFim"
                                v-mascara="'data-mask'"
                                v-model="solicitacao.dataVigenciaFim"
                                format="dd/MM/yyyy"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="dataVigenciaFim"
                                data-vv-as="vigência fim"
                                v-validate="'required|date_format:DD/MM/YYYY'">
                    </datepicker>

                    <p class="text-danger" v-show="errors.has('dataVigenciaFim')">{{ errors.first('dataVigenciaFim') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div :class="{'col-xs-12': this.configuracao.ocultarSubTipoContrato, 'col-xs-6': !this.configuracao.ocultarSubTipoContrato}">
                <div class="form-group">
                    <label class="control-label" for="tipo-contrato">Tipo contrato</label>

                    <select class="form-control"
                            id="tipo-contrato"
                            v-model="solicitacao.idTipoContrato"
                            @change="carregarSubTiposContrato">
                        <option value="">Selecione...</option>
                        <option :value="tipoContrato.idTipoContrato" v-for="tipoContrato in tiposContrato">{{ tipoContrato.nome }}</option>
                    </select>
                </div>
            </div>

            <div class="col-lg-6" v-if="!this.configuracao.ocultarSubTipoContrato">
                <div class="form-group">
                    <label class="control-label" for="subtipo-contrato">Subtipo contrato</label>

                    <select class="form-control"
                            id="subtipo-contrato"
                            v-model="solicitacao.idSubTipoContrato">
                        <option value="">Selecione...</option>
                        <option :value="subTipoContrato.idSubTipoContrato" v-for="subTipoContrato in subTiposContrato">{{ subTipoContrato.nome }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group" :class="{'required': this.configuracao.solBolsaObrigatorioObjetivo,'has-error': errors.has('objetivo')}">
                    <label class="control-label" for="objetivo">Objetivo</label>

                    <textarea class="form-control"
                              id="objetivo"
                              v-model="solicitacao.objetivo"
                              data-vv-name="objetivo"
                              data-vv-as="objetivo"
                              v-validate="this.configuracao.solBolsaObrigatorioObjetivo ? 'required' : ''">
                    </textarea>

                    <p class="text-danger" v-show="errors.has('objetivo')">{{ errors.first('objetivo') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group" :class="{'required': fap,'has-error': errors.has('observacao')}">
                    <label class="control-label" for="descricao">Observação</label>

                    <textarea class="form-control"
                              id="descricao"
                              v-model="solicitacao.observacao"
                              data-vv-name="observacao"
                              data-vv-as="observação"
                              v-validate="fap ? 'required' : ''">
          </textarea>

                    <p class="text-danger" v-show="errors.has('observacao')">{{ errors.first('observacao') }}</p>
                </div>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa/componentes/compartilhado/FormDadosBolsa.vue